import { render, staticRenderFns } from "./Topic2PveAward.vue?vue&type=template&id=03842009&scoped=true"
import script from "./Topic2PveAward.vue?vue&type=script&lang=js"
export * from "./Topic2PveAward.vue?vue&type=script&lang=js"
import style0 from "./Topic2PveAward.vue?vue&type=style&index=0&id=03842009&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03842009",
  null
  
)

export default component.exports